import Vue from 'vue'

const MenuDefault = Vue.component('menu-default', {
  props: ["data"],
  template: '#menu_default'
})

export default MenuDefault;
